import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M2 12h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 12h-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 8v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 14v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 20v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m19 9-3 3 3 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5 15 3-3-3-3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FoldHorizontal";
const FoldHorizontal = memo(themed(Icon));
export {
  FoldHorizontal
};
//# sourceMappingURL=fold-horizontal.js.map
